"use client";

import { motion } from "framer-motion";

export function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  const navLinks = [
    { name: "Showcase", id: "showcase" },
    { name: "Features", id: "features" },
    { name: "Gallery", id: "gallery" },
    { name: "Reviews", id: "reviews" },
    { name: "Pricing", id: "pricing" },
  ];

  return (
    <footer className="border-t border-border bg-background overflow-hidden">
      <motion.div 
        className="mx-auto max-w-7xl px-6 lg:px-10 py-16"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={containerVariants}
      >
        <div className="flex flex-col md:flex-row items-center justify-between gap-12">
          <motion.div variants={itemVariants} className="text-center md:text-left">
            <div className="text-2xl font-bold tracking-tight">
              Apollo<span className="text-[#0055FF]">.</span>
            </div>
            <p className="mt-3 text-sm text-muted-foreground max-w-xs">
              The center of your home. Engineered for elegance and privacy.
            </p>
          </motion.div>

          <motion.nav variants={itemVariants}>
            <ul className="flex flex-wrap justify-center gap-x-8 gap-y-4">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => scrollToSection(e, link.id)}
                    className="text-sm font-medium text-foreground/70 hover:text-[#0055FF] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </motion.nav>
        </div>
        
        <motion.div 
          variants={itemVariants}
          className="mt-16 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-6 text-[10px] uppercase tracking-widest font-bold text-muted-foreground"
        >
          <div>© 2026 Apollo Home, Inc. All rights reserved.</div>
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
            Designed in California
          </div>
        </motion.div>
      </motion.div>
    </footer>
  );
}
